module.exports = __webpack_public_path__ + "static/media/Fs1v6.2b9269d9.mp3";